export const UNIFIED_SIMULATOR_ENDPOINT_FLAG = 'unified-simulator-endpoint'
